// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"673a1f6e","605":"d6228902","809":"62452d41","981":"8d3f8196"}[chunkId] + ".chunk.js";
};